// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropbox[data-v-30d07e24]{outline:2px dashed grey;outline-offset:-10px;background:transparent;color:#696969;padding:10px 10px;min-height:200px;position:relative;border-radius:4px}.dropbox[data-v-30d07e24]:hover{background:#f6f6f6}.input-file[data-v-30d07e24]{opacity:0;width:100%;height:200px;position:absolute;cursor:pointer}", ""]);
// Exports
module.exports = exports;
